// https://vuex.vuejs.org/en/state.html

export default {
  basket: {
    customerId: "",
    items: []
  },
  list: []
};
